<template>
  <div class="full-height">
    <div class="fit container-crud no-padding no-margin">
      <div class="fit no-padding no-margin">
        <q-card class="fit no-padding no-margin" flat>
          <q-scroll-area id="concession-contract-page-person" class="container-page-person shadow-1 no-padding no-margin">
            <q-card-section class="q-py-sm">
              <div v-if="nmInterface === 'gravar'" class="crud-title">
                <translate>NEW_REGISTRATION</translate>
              </div>
              <div v-else-if="nmInterface === 'alterar'" class="crud-title">
                <translate>UPDATE</translate>
              </div>
              <div v-else-if="nmInterface === 'detalhar'" class="crud-title">
                <translate>VIEW_REGISTRATION</translate>
              </div>
            </q-card-section>
            <q-card-section class="q-px-sm container-person">
              <div v-if="elements.length == 1" class="concession-contract-form-wrapper">
                <jt-dynamic-form
                    ref="dynamicForm"
                    :inputs="inputs"
                    :relacionamentos="elements[0].relacionamentos"
                    :model="elements[0].dadosForm"
                    :interface="elements[0].nmInterface"
                    form-class="form dynamic concession-contract-dynamic-form"
                  />
              </div>
            </q-card-section>
            <q-card-section>
              <q-tabs
                id="jt-compositions"
                v-model="tab"
                align="start"
                color="dark"
                dense
                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  :key="0"
                  name="xtab-0"
                  :label="compositions[0].label"
                  :icon="compositions[0].icon"
                  :default="index === 0"
                />
                <q-tab
                  :key="0"
                  name="xtab-1"
                  :label="compositions[1].label"
                  :icon="compositions[1].icon"
                  :default="index === 1"
                />
                <q-tab
                  :key="0"
                  name="xtab-2"
                  :label="compositions[2].label"
                  :icon="compositions[2].icon"
                  :default="index === 2"
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel :key="index" :name="'xtab-0'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[0].columns"
                    :data="compositions[0].data"
                    :buttons="compositions[0].buttons"
                    v-key="compositions[0].model"
                    :allow-custom-edit-modal="true"
                    @on-add="newConcessionContractTariff"
                    @on-edit="editConcessionContractTariff"
                    @action-click="actionButtonComposition"
                  />
                </q-tab-panel>
                <q-tab-panel :key="index" :name="'xtab-1'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[1].columns"
                    :data="compositions[1].data"
                    :buttons="compositions[1].buttons"
                    v-key="compositions[1].model"
                  />
                </q-tab-panel>
                <q-tab-panel :key="index" :name="'xtab-2'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[2].columns"
                    :data="compositions[2].data"
                    :buttons="compositions[2].buttons"
                    v-key="compositions[2].model"
                  />
                </q-tab-panel>
              </q-tab-panels>
            </q-card-section>
          </q-scroll-area>
        </q-card>
      </div>
    </div>
    <div
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn
          class="full-width"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <concession-contract-tariff v-if="concessionContractTariffShow"
    ref="concessionContractTariffModal"
    :form="concessionContractTariffForm"
    :composicaos="concessionContractTariffData"
    :nr-linha-selecionada="concessionContractTariffForm.nrLinhaSelecionada"
    :fl-composicao-alteracao="editMode"
    @onAddSuccess="onAddConcessionContractTariffSuccessHandler"
    @onEditSuccess="onEditConcessionContractTariffSuccessHandler"
    >

    </concession-contract-tariff>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtComposition } from 'jtech-webcomps'
import { QTab, QTabPanel, QTabPanels } from 'quasar'
import ConcessionContractTariff from './ConcessionContractTariff.vue'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'ConcessionContractPage',
  components: {
    JtDynamicForm,
    JtComposition,
    page,
    QTab,
    QTabPanel,
    QTabPanels,
    ConcessionContractTariff
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class ConcessionContractPage extends Vue {
  nmInterface = null;
  editMode = false;
  concessionContractTariffShow = false
  tab = 'xtab-0'
  concessionContractTariffForm = {}
  concessionContractTariffData = []

  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  get inputs () {
    return this.elements[0].inputs.filter(
      (ci) => ci.type !== 'COMPOSICAO'
    )
  }

  actionButtonComposition (button) {
    this.$emit('composition-button-click', button)
  }

  openConcessionContractTariff (data) {
    data.dadosForm = {
      ...data.dadosForm,
      concessionContract: this.elements[0].dadosForm.id,
      concessionContractFinal: this.elements[0].dadosForm.id + ' - ' + this.elements[0].dadosForm.name
    }
    this.concessionContractTariffShow = true
    this.concessionContractTariffForm = { ...data }
    this.concessionContractTariffData = this.elements[0].dadosForm.concessionContractTariffs
    this.$nextTick(() => {
      this.$refs.concessionContractTariffModal.show()
    })
  }

  limparForm () {
    this.$refs.dynamicForm.resetForm()
    this.elements[0].dadosForm.concessionContractTariffs = []
  }

  newConcessionContractTariff (data) {
    this.editMode = false
    this.openConcessionContractTariff(data)
  }

  async editConcessionContractTariff (data) {
    this.editMode = true
    const id = data.dadosForm && data.dadosForm.id
    if (id) {
      try {
        const forms = await repository.resolve('concessionContractTariff.composicao', { id })
        const fullForm = Array.isArray(forms) ? forms[0] : forms
        const formToOpen = {
          ...data,
          ...fullForm,
          dadosForm: fullForm.dadosForm || data.dadosForm,
          nrLinhaSelecionada: data.nrLinhaSelecionada
        }
        this.openConcessionContractTariff(formToOpen)
      } catch (e) {
        console.error('editConcessionContractTariff', e)
        this.openConcessionContractTariff(data)
      }
    } else {
      this.openConcessionContractTariff(data)
    }
  }

  onAddConcessionContractTariffSuccessHandler (dados) {
    try {
      this.elements[0].dadosForm.concessionContractTariffs.push(dados)
      this.$refs.concessionContractTariffModal.hide()
      this.concessionContractTariffShow = true
    } catch (error) {
      console.error('onAddConsumerUnitAddressSuccessHandler', error)
    }
  }

  onEditConcessionContractTariffSuccessHandler (dados) {
    try {
      const index = dados.nrLinhaSelecionada

      Object.assign(this.elements[0].dadosForm.concessionContractTariffs[index], dados)
      this.$refs.concessionContractTariffModal.hide()
      this.concessionContractTariffShow = true
    } catch (error) {
      console.error('onEditConcessionContractTariffSuccessHandler', error)
    }
  }

  get compositions () {
    const compositions = this.formateInputsArray()
    return (
      // eslint-disable-next-line no-undef
      _.chain(compositions)
        .find((ci) => ci.type === 'composition')
        .get('elements')
        .forEach((e) => {
          e.data = this.elements[0].dadosForm[e.model]
          e.uuid = 'id'
          e.columns.forEach((col) => {
            col.name = col.name || col.model
            col.field = col.name
            col.sortable = true
            col.align = 'left'
          })
        })
        .value() ?? []
    )
  }

  formateInputsArray () {
    // eslint-disable-next-line no-undef
    return _.chain(this.elements[0].inputs)
      .orderBy((input) => input.type === 'COMPOSICAO', ['asc'])
      .groupBy((input) =>
        input.type === 'COMPOSICAO' ? 'composition' : 'input'
      )
      .toPairs()
      // eslint-disable-next-line no-undef
      .map((item) => _.zipObject(['type', 'elements'], item))
      .value()
  }
}
export default ConcessionContractPage
</script>
<style lang="stylus" scoped>

@import '~quasar-variables';

// Ajustes exclusivos para a tela de contrato de concessão

#concession-contract-page-person.container-page-person {
  height: 1000px !important;
  min-height: 0 !important;
  width: 100% !important;
  min-width: 800px !important; /* Largura mínima para comportar o formulário */
  font-size: 0.98em;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: auto !important; /* Permite scroll horizontal quando necessário */
  overflow-y: auto !important;
  position: relative !important;
}

</style>

<style>
#concession-contract-page-person.q-scrollarea .q-scrollarea__container > .q-scrollarea__content.absolute,
#concession-contract-page-person .dynamic-form .q-scrollarea__container > .q-scrollarea__content.absolute,
.concession-contract-dynamic-form .q-scrollarea__content.absolute {
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  transform: none !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}

#concession-contract-page-person.q-scrollarea .q-scrollarea__container,
.concession-contract-dynamic-form .q-scrollarea__container {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  position: relative !important;
  overflow: hidden !important;
}

#concession-contract-page-person .jt-composition-container .q-table__container,
#concession-contract-page-person .jt-composition-container .q-table,
#concession-contract-page-person .jt-composition-container .q-table__middle,
#concession-contract-page-person .jt-composition-container .q-table__card,
#concession-contract-page-person .jt-composition-container .dynamic-compositions .q-table__container {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: auto !important;
}

.container-crud #concession-contract-page-person .dynamic-form #scroll-area {
  height: 600px;
}

</style>
